import ActionTypes from "../../../constants";
import { ChangeLogPayloadType, ChangeLogType, UserType } from '../types';
import { PaginationInfoType } from "../../BusinessPartnerLists/types";

export interface FetchChangeLogActionType {
  type: typeof ActionTypes.FETCH_CHANGE_LOG,
  payload: ChangeLogPayloadType
}

export const fetchChangeLog = (payload: ChangeLogPayloadType): FetchChangeLogActionType => ({
  type: ActionTypes.FETCH_CHANGE_LOG,
  payload,
})

export const resetChangeLogData = () => ({
  type: ActionTypes.RESET_DATA
})

export interface FetchChangeLogSuccededActionType {
  type: typeof ActionTypes.FETCH_CHANGE_LOG_SUCCEEDED,
  changeLog: ChangeLogType[]
  paginationInfo: PaginationInfoType;
}

export const fetchChangeLogSucceeded = (changeLog: ChangeLogType[], paginationInfo: PaginationInfoType): FetchChangeLogSuccededActionType => ({
  type: ActionTypes.FETCH_CHANGE_LOG_SUCCEEDED,
  changeLog,
  paginationInfo
})

export interface FetchUsersActionType {
  type: typeof ActionTypes.FETCH_USERS
}

export const fetchUsers = (): FetchUsersActionType => ({
  type: ActionTypes.FETCH_USERS
})

export interface FetchUsersSucceededActionType {
  type: typeof ActionTypes.FETCH_USERS_SUCCEEDED;
  users: UserType[];
}

export const fetchUsersSucceeded = (users: UserType[]): FetchUsersSucceededActionType => ({
  type: ActionTypes.FETCH_USERS_SUCCEEDED,
  users,
})